import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { productPropTypes, routerPropTypes } from 'Types'
import get from 'lodash/get'
import { withRouter } from 'react-router'
import { StoreProductsResponse } from '../../../components'
import { PanelTrigger } from '../components'
import ProductList from '../../ProductList'
import { AppliedFilters, ItemsFound } from 'Blocks'
import { PAGE_CONTEXT as p } from 'Constants'
import NoSearch from '../../NoSearch'
import config from 'Config'

const pageName = p.PRODUCT_LIST

const Large = props => {
  const { data } = props
  const isSearch = props.params.subCategory === 'search'
  const products = get(data, 'products.products', [])

  const heading = (() => {
    const termMatch = props.location.search.match(/term=([^&]*)/)
    const formatTerm = term => decodeURIComponent(term).replace(/\+/g, ' ')
    const term = termMatch ? formatTerm(termMatch[1]) : null

    if (isSearch && data.products.length === 0) {
      return <h1 className="heading">Nothing found for: {`${term}`}</h1>
    } else if (isSearch) {
      return (
        <Fragment>
          <div className="heading-term">
            {config.searchResults.label
              ? config.searchResults.label
              : 'Your search results for:'}{' '}
          </div>
          <h1 className="heading search-term">{`${term}`}</h1>
        </Fragment>
      )
    } else {
      return (
        <h1 className="heading">{data.products.categories.current.name}</h1>
      )
    }
  })()

  const noSearchProps = {
    ...props,
    className: ''
  }

  if (isSearch && products.length === 0) {
    return <NoSearch {...noSearchProps} />
  }
  if (props.showOnlyProductList) return <ProductList {...props} {...data} />
  return (
    <Fragment>
      <StoreProductsResponse data={data} location={props.location} />
      {heading}
      <PanelTrigger />
      <div className="feedback">
        <AppliedFilters pageName={pageName} />
        <ItemsFound />
      </div>
      <ProductList {...props} {...data} />
    </Fragment>
  )
}

Large.propTypes = {
  data: PropTypes.shape({
    products: PropTypes.shape({
      categories: PropTypes.any,
      products: PropTypes.arrayOf(PropTypes.shape(productPropTypes))
    })
  }),
  ...routerPropTypes
}

export default withRouter(Large)
